import { checkIsInterpack } from "../../../../../infrastructures/misc/common-library/DetectLanguage";
import {
  MultilingualText,
  renderMultilingualText
} from "../../../../../infrastructures/misc/js-pdf copy/render-multilingual-text";
import { limitLengthName } from "../../module";

export const senderRecipientFooter = async (params: any) => {
  const doc = params.doc;
  const product = params.data.sttProductType;

  const startX = params.startX + 15;
  const senderY = params.startY;
  const recipientY = params.startY + 2.5;

  const maxWidth = checkIsInterpack(product) ? 13 : 19;

  await renderMultilingualText(
    new MultilingualText({
      doc,
      text: limitLengthName(params.data.sttSenderName.toUpperCase(), maxWidth),
      product,
      startX,
      startY: senderY,
      maxWidth: maxWidth + 2,
      fontSize: 5,
      fontStyle: "bold",
      maxLines: 1
    })
  );

  await renderMultilingualText(
    new MultilingualText({
      doc,
      text: limitLengthName(
        params.data.sttRecipientName.toUpperCase(),
        maxWidth
      ),
      product,
      startX,
      startY: recipientY,
      maxWidth: maxWidth + 2,
      fontSize: 5,
      fontStyle: "bold",
      maxLines: 1
    })
  );
};
